import { MutationTree } from 'vuex';
import { MENU } from './mutation-types';
import { MenuState } from './state';
import { Site } from '@/models/Site';
import { StatutBim } from '@/models/StatutBim';

export const mutations: MutationTree<MenuState> = {
    [MENU.SET_MENU](state, items: any[]) {
        state.menu = items;
    },
    [MENU.SET_CHOIX_MENU](state, choix: string) {
        state.choixMenu = choix;
    },
    [MENU.SET_SITES](state: MenuState, sites: Site[]) {
        state.listeSiteDisponibles = sites;
    },
    [MENU.SET_ONBOARDING_OPEN](state, open: boolean) {
        state.onBoardingOpen = open;
    },
    [MENU.SET_STATUT_BIM](state: MenuState, statut: StatutBim) {
        state.statutBim = statut;
    }
};

